// extracted by mini-css-extract-plugin
module.exports = {"resourcesBlock":"ResourcesBlock_resourcesBlock__38fh9"};